import React from 'react';
import { Typography } from '@material-ui/core';
import './style.scss';

const ErrorMessage = ({ error }) => (
  <div className="ErrorMessage">
    <Typography variant="h5">{error.toString()}</Typography>
  </div>
);

export default ErrorMessage;
